import { render } from "./Book.vue?vue&type=template&id=6ffe3318&scoped=true"
import script from "./Book.vue?vue&type=script&lang=js"
export * from "./Book.vue?vue&type=script&lang=js"

import "./Book.vue?vue&type=style&index=0&id=6ffe3318&lang=scss&scoped=true"

import exportComponent from "/Users/richardpitul/Projects/booking-calendars/athletics-booking-calendar/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffe3318"]])

export default __exports__